import React from 'react';
import { parseDomain } from '@wix/domains-serverless-interface';
import { PerceptionNote } from './PerceptionNote';
export const PerceptionCardNote = _ref => {
  let {
    row,
    domain,
    bulletAligned = false
  } = _ref;
  const {
    tld
  } = parseDomain(domain);
  if (!row.cardNote) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PerceptionNote, {
    labelKey: row.cardNote.labelKey,
    values: {
      tld: `.${tld}`
    },
    withIcon: row.cardNote.withIcon,
    size: "medium",
    variant: bulletAligned ? 'bullet' : 'inline',
    dataHook: "price-card-note"
  });
};
//# sourceMappingURL=PerceptionCardNote.js.map